// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkboxContainer {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  grid-gap: 8px;
  max-width: 100%;

}

.hiddenProviderCheckbox {
  display: none;
}

.checkboxLabel {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button {
  background-color: var(--theme-consistent);
  border: none;
  color: white;
  border-radius: 10px;
  padding: 4px 16px 4px 16px;
  width: 100%;
  height: 100%;
}

.button.movies {
  background-color: var(--theme-consistent);
  border: none;
  color: white;
  border-radius: 10px;
  padding: 4px 16px 4px 16px;
}

.button.shows {
  background-color: var(--theme-consistent);
  border: none;
  color: white;
  border-radius: 10px;
  padding: 4px 16px 4px 16px;
}

.button.popular {
  background-color: var(--theme-consistent);
  border: none;
  color: white;
  border-radius: 10px;
  padding: 4px 16px 4px 16px;
}

.checkboxLabel.provider {
  display: inline-block;
}

.providerImage {
  width: 85%;
  max-height: 130px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  opacity: 1;
  transition: opacity 0.2s;
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
}

.providerWrapper.checked {
  /* background-color: rgba(0, 0, 0, 0.1); */
  border-radius: 5px;
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
}

.providerImagechecked {
  width: 85%;
  height: 90px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  opacity: 0.25;
  transition: opacity 0.2s;
}

.providerImage.providerImagechecked {
  opacity: 0.35;
  box-shadow: none;
}

.button.buttonSelected {
  opacity: 0.35;
  transition: opacity 0.2s;
  box-shadow: none;
}

/* Mobile devices */
/* @media screen and (max-width: 767px) {
  .checkboxContainer {
    grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
    font-size: 14px;
  }

  .providerImage {
    width: 80%;
  }
} */

/* iPad/Tablet devices */
/* @media screen and (min-width: 768px) and (max-width: 1024px) {
  .checkboxContainer {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    font-size: 16px;
  }

  .providerImage {
    width: 85%;
  }
} */

/* Computers/Laptops */
/* @media screen and (min-width: 1025px) {
  .checkboxContainer {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    font-size: 18px;
  }

  .providerImage {
    width: 85%;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/assets/Checkbox.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4DAA4D;EAC5D,aAAa;EACb,eAAe;;AAEjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;EACV,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;;;;;;;;;GASG;;AAEH,wBAAwB;AACxB;;;;;;;;;GASG;;AAEH,sBAAsB;AACtB;;;;;;;;;GASG","sourcesContent":[".checkboxContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  grid-gap: 8px;\n  max-width: 100%;\n\n}\n\n.hiddenProviderCheckbox {\n  display: none;\n}\n\n.checkboxLabel {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.button {\n  background-color: var(--theme-consistent);\n  border: none;\n  color: white;\n  border-radius: 10px;\n  padding: 4px 16px 4px 16px;\n  width: 100%;\n  height: 100%;\n}\n\n.button.movies {\n  background-color: var(--theme-consistent);\n  border: none;\n  color: white;\n  border-radius: 10px;\n  padding: 4px 16px 4px 16px;\n}\n\n.button.shows {\n  background-color: var(--theme-consistent);\n  border: none;\n  color: white;\n  border-radius: 10px;\n  padding: 4px 16px 4px 16px;\n}\n\n.button.popular {\n  background-color: var(--theme-consistent);\n  border: none;\n  color: white;\n  border-radius: 10px;\n  padding: 4px 16px 4px 16px;\n}\n\n.checkboxLabel.provider {\n  display: inline-block;\n}\n\n.providerImage {\n  width: 85%;\n  max-height: 130px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 10px;\n  opacity: 1;\n  transition: opacity 0.2s;\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n}\n\n.providerWrapper.checked {\n  /* background-color: rgba(0, 0, 0, 0.1); */\n  border-radius: 5px;\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n}\n\n.providerImagechecked {\n  width: 85%;\n  height: 90px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 10px;\n  opacity: 0.25;\n  transition: opacity 0.2s;\n}\n\n.providerImage.providerImagechecked {\n  opacity: 0.35;\n  box-shadow: none;\n}\n\n.button.buttonSelected {\n  opacity: 0.35;\n  transition: opacity 0.2s;\n  box-shadow: none;\n}\n\n/* Mobile devices */\n/* @media screen and (max-width: 767px) {\n  .checkboxContainer {\n    grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));\n    font-size: 14px;\n  }\n\n  .providerImage {\n    width: 80%;\n  }\n} */\n\n/* iPad/Tablet devices */\n/* @media screen and (min-width: 768px) and (max-width: 1024px) {\n  .checkboxContainer {\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    font-size: 16px;\n  }\n\n  .providerImage {\n    width: 85%;\n  }\n} */\n\n/* Computers/Laptops */\n/* @media screen and (min-width: 1025px) {\n  .checkboxContainer {\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n    font-size: 18px;\n  }\n\n  .providerImage {\n    width: 85%;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
